<template>
  <div>
    <v-btn
      icon
      v-if="application.indexOf('3') != -1"
      @click.stop="push('3')"
      class="ma-1"
    >
      <v-icon>mdi-heart-outline</v-icon>
    </v-btn>
    <v-btn
      icon
      v-if="application.indexOf('1') != -1"
      @click.stop="push('1')"
      class="ma-1"
    >
      <v-icon>mdi-auto-fix</v-icon>
    </v-btn>
    <v-btn
      icon
      v-if="application.indexOf('2') != -1"
      @click.stop="push('2')"
      class="ma-1"
    >
      <v-icon>mdi-school</v-icon>
    </v-btn>

    <!-- <v-btn icon @click.stop="push('0')" class="ma-1">
      <v-icon>mdi-monitor</v-icon>
    </v-btn> -->
  </div>
</template>

<script>
export default {
  name: "TheApplicationIcons",
  props: { application: { type: Array, default: () => [] } },
  data: () => ({}),
  computed: {},
  methods: {
    push(to) {
      if (this.$route.path != `/cards/${to}`) {
        this.$router.push({ name: "Cards", params: { application: to } });
      }
    },
  },
};
</script>
